











































































import AbpBase from "../../../lib/abpbase";
import {Component, Vue, Inject, Prop, Watch} from 'vue-property-decorator';
import {GetWardList, InsertWard, UpdateWardById, DeleteWard} from '../../../api/specialDictionary'
import {GetPinYin, GetWuBi} from '../../../api/sys'
import {GetListByCode} from "@/api/configureDictionary"

@Component
export default class Country extends AbpBase {
	cancel(){
		this.dialogFormVisible = false
	}
	visibleChange(value: boolean) {
		if (!value) {
			this.dialogFormVisible = false;
			(this.$refs.form as any).resetFields()
			this.getData()
		}
	}
	columns = [
		{
			key: 'wardName',
			title: '病区名称'
		},
		{
			key: 'wardPY',
			title: '拼音助记符'
		},
		{
			key: 'wardWB',
			title: '五笔助记符'
		},
		{
			key: 'wardSx',
			title: '病区属性'
		},
		{
			key: 'wardnum',
			title: '排序号'
		},
		{
			key: 'status',
			title: '是否启用',
			render:(h:any, p:any)=>{
				return h('span', p.row.status ? '启用' : '禁用')
			}
		},
		{
			key: '',
			width: 190,
			title: '操作',
			render:(h:any, p:any)=>{
				return h('div', [
					h('Button',{
						props:{type: 'primary'},
						style:{marginRight:'20px'},
						on:{
							click:()=>{
								this.edit(p.row)
							}
						}
					},'编辑'),
					h('Button',{
						props:{type: 'error'},
						on:{
							click:()=>{
								this.del(p.row)
							}
						}
					},'删除'),
				])
			}
		},
	]
	key = '' //查询条件
	page = 1 //当前页
	dialogTitle = ''
	dialogForm: any = {}
	dialogFormVisible = false
	dialogFormLabelWidth = '100px'
	tableTotalSize = 0
	tableData = []
	tableLoading = false
	wardSxs = [] // 病区下拉
	created() {
		this.getData()
		this.getSelects()
	}

	//获取拼音五笔
	async getCode(val: any) {
		let query = {inputStr: val}
		let res1 = await GetPinYin(query)
		let res2 = await GetWuBi(query)
		this.dialogForm.wardPY = res1
		this.dialogForm.wardWB = res2
	}

	async getSelects(){
		let res = await GetListByCode({input:'024'})
		this.wardSxs = res
	}

	createCounty() {
		this.dialogTitle = '新增病区'
		this.dialogForm = {status: true, wardPY: '', wardWB: ''}
		this.dialogFormVisible = true
	}

	private async getData() {
		this.tableLoading = true
		let res = await GetWardList({
			QueryString: this.key,
			SkipCount: this.page,
			MaxResultCount: 10
		})
		this.tableData = res.items
		this.tableTotalSize = res.totalCount
		this.tableLoading = false
	}

	handleClose() {
		this.dialogFormVisible = false
	}

	edit(row: any) {
		this.dialogTitle = '编辑病区'
		this.dialogForm = JSON.parse(JSON.stringify(row))
		this.dialogFormVisible = true
	}

	async del(row: any) {
		this.$confirm('此操作将永久删除该记录, 是否继续?', '提示', {
			confirmButtonText: '确定',
			cancelButtonText: '取消',
			type: 'warning'
		}).then(async () => {
			let res = await DeleteWard({Id: row.id})
			this.getData()
		}).catch(() => {

		});

	}

	async confirm() {

		(this.$refs.form as any).validate(async (valid:boolean)=>{
			if(valid){
				if (this.dialogTitle === '新增病区') {
					let res = await InsertWard(this.dialogForm)
				} else if (this.dialogTitle === '编辑病区') {
					let res = await UpdateWardById(this.dialogForm)
				}
				this.dialogFormVisible = false
				this.getData()
			}
		})
	}

	rules = {
		wardName: [{required: true, message: '请输入内容', trigger: 'blur'}],
		wardPY: [{required: true, message: '请输入内容', trigger: 'blur'}],
		wardWB: [{required: true, message: '请输入内容', trigger: 'blur'}],
	}

	pageChange(val: any) {
		this.page = val
		this.getData()
	}
}



// WEBPACK FOOTER //
// ./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/views/specialDictionary/ward/index.vue